import React, { useEffect } from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import { reverseFormatDate } from '../../../utils/dateFunctions';
import { downloadCsv } from '../../../utils/downloadCSV';
import DataSetsResultsModal from '../DataSetsResultsModal';

const fields =
    'Service,Adviser,PT_ID,Unique_ID,First_Name,Last_Name,Referral_Date,Current_Status,Appointment_Date,Appointment_Time,Appointment_Type,Interviewer,Location,Appointment_Attendance,PO_Number';

const WAIT = 5000;

const CreateAttendanceOutcomesCsv = ({
    selectedAttendanceStatuses,
    isOpen,
    onClose,
    rows,
    contractName
}) => {
    // USEEFFECTS
    useEffect(() => {
        const values = Object.values(
            rows.map((el) => {
                // eslint-disable-next-line
                const { rowId, ...rest } = el;
                const formattedRow = {
                    ...rest,
                    referralDate: reverseFormatDate(el.referralDate),
                    appointmentDate: reverseFormatDate(el.appointmentDate)
                };
                return Object.values(formattedRow);
            })
        );
        const name = `${selectedAttendanceStatuses.map((el) => el.name).join('/')}_${contractName}_${format(
            new Date(),
            `dd_MMM_yyyy_HH_mm`
        )}`;

        downloadCsv(fields, values, name);
        const timerId = setTimeout(() => onClose(), WAIT);
        return () => clearTimeout(timerId);
    }, [rows]);

    // RENDER
    return (
        <DataSetsResultsModal
            isOpen={isOpen}
            onCancel={onClose}
            resultRowsLength={rows.length || 0}
            dataSetName="Attendance Outcome"
        />
    );
};

CreateAttendanceOutcomesCsv.propTypes = {
    selectedAttendanceStatuses: PropTypes.arrayOf(PropTypes.string),
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    rows: PropTypes.arrayOf(PropTypes.object),
    contractName: PropTypes.string
};

export default CreateAttendanceOutcomesCsv;
